<template>
  <loading-spinner
    v-if="loading"
    :no-text="true"
    class="tw-py-0.5 tw-px-2.5"
  />
  <multiselect
    v-else
    :value="formatedValues.all"
    :options="options"
    :multiple="true"
    :preserve-search="currentBrowser.isExplorer"
    :disabled="isDisabled"
    :group-values="(teamsEnabled) ? 'items': null"
    :group-label="(teamsEnabled) ? 'collection': null"
    :placeholder="$t('select')"
    track-by="name"
    label="name"
    @input="onChange"
  >
    <template slot="noResult">
      {{ $t('noResultsFound') }}
    </template>
  </multiselect>
</template>

<script>
import LoadingSpinner from '@/components/common/LoadingSpinner';
import { GET_ACTIVE_CLINICIANS, GET_ALL_CLINICIANS_TEAMS } from '@/store/modules/clinicians/constants.js';
import Multiselect from 'vue-multiselect';
import { mapGetters } from 'vuex';

export default {
  name: 'CliniciansTeamsSelector',
  components: {
    LoadingSpinner,
    Multiselect
  },
  props: {
    value: [Object], // eslint-disable-line
    teamsEnabled: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      formatedValues: {},
      originalValues: {}
    }
  },
  computed: {
    ...mapGetters({
      currentBrowser: 'getCurrentBrowser',
      clinicianTeams: 'getClinicianTeams',
      allClinicians: 'getClinicians',
      cliniciansLoading: 'getCliniciansLoading',
      clinicianTeamsLoading: 'getClinicianTeamsLoading'
    }),
    action () {
      return this.$route.params.programId ? 'update' : 'create'
    },
    clinicians () {
      return this.allClinicians.map(clinician => {
        return {
          id: clinician.id,
          name: clinician.name,
          type: 'clinician'
        }
      })
    },
    teams () {
      return this.clinicianTeams.map(team => {
        return {
          id: team.id,
          name: team.name,
          type: 'team'
        }
      })
    },
    options () {
      if (!this.teamsEnabled) {
        return this.clinicians
      } else {
        return [
          {
            collection: 'Clinicians',
            items: this.clinicians
          },
          {
            collection: 'Clinician Teams',
            items: this.teams
          }
        ]
      }
    },
    loading () {
      return this.cliniciansLoading || this.clinicianTeamsLoading
    }
  },
  created () {
    const teamsPromise = this.$store.dispatch(GET_ALL_CLINICIANS_TEAMS, { paginate: false })
    const cliniciansPromise = this.$store.dispatch(GET_ACTIVE_CLINICIANS)
    Promise.all([teamsPromise, cliniciansPromise]).finally(() => {
      this.setInitialValues(this.value)
    })
  },
  methods: {
    onChange (value, isInitialize) {
      isInitialize = isInitialize === true
      const clinicians = value.filter(obj => obj.type === 'clinician').map(obj => obj.id)
      const cliniciansFromPrograms = value.filter(obj => obj.type === 'clinicianFromProgram').map(obj => obj.id)
      const teams = value.filter(obj => obj.type === 'team').map(obj => obj.id)
      const teamsFromPrograms = value.filter(obj => obj.type === 'teamFromProgram').map(obj => obj.id)

      this.formatedValues = {
        clinicians,
        cliniciansFromPrograms,
        teamsFromPrograms,
        teams,
        all: value
      }

      if (isInitialize) {
        this.originalValues = { ...this.formatedValues }
        return
      }

      if (!value.length) {
        return this.$emit('input', undefined)
      }

      this.$emit('input', this.formatedValues)
    },
    setInitialValues (value) {
      const result = []

      const clinicians = value.clinicians || []
      if (clinicians && clinicians.length) {
        clinicians.forEach(id => {
          const match = this.clinicians.find(obj => parseInt(obj.id) === parseInt(id))
          if (match) {
            result.push(match)
          }
        })
      }

      const teams = value.teams || []
      if (teams && teams.length) {
        teams.forEach(id => {
          const match = this.teams.find(obj => parseInt(obj.id) === parseInt(id))
          if (match) {
            result.push(match)
          }
        })
      }

      const cliniciansFromPrograms = value.cliniciansFromPrograms || []
      if (cliniciansFromPrograms && cliniciansFromPrograms.length) {
        cliniciansFromPrograms.forEach(id => {
          // Check if clinician is not already assigned directly
          const already = result.find(obj => parseInt(obj.id) === parseInt(id));
          if (!already) {
            const match = this.clinicians.find(obj => parseInt(obj.id) === parseInt(id))
            if (match) {
              match.type = 'clinicianFromProgram'
              result.push(match)
            }
          }
        })
      }

      const teamsFromPrograms = value.teamsFromPrograms || []
      if (teamsFromPrograms && teamsFromPrograms.length) {
        teamsFromPrograms.forEach(id => {
          // Check if team is not already assigned directly
          const already = result.find(obj => parseInt(obj.id) === parseInt(id));
          if (!already) {
            const match = this.teams.find(obj => parseInt(obj.id) === parseInt(id))
            match.type = 'teamFromProgram'
            if (match) {
              result.push(match)
            }
          }
        })
      }
      this.onChange(result, true)
    },
    resetValues () {
      this.formatedValues = { ...this.originalValues }
      this.$emit('input', this.formatedValues)
    },
    commitValues () {
      this.originalValues = { ...this.formatedValues }
    },
    setValues (values) {
      this.setInitialValues(values)
    }
  }
}
</script>
<style lang="scss">
.patientClinicianTeam.multiselect--disabled {
  @apply tw-opacity-100;
  > .multiselect__select {
    @apply tw-hidden;
  }
  > .multiselect__tags {
    @apply tw-border-0;
    > .multiselect__tags-wrap >.multiselect__tag {
      @apply tw-pr-[10px] tw-bg-[#83909d];
      i {
        @apply tw-hidden;
      }
    }
    > .multiselect__placeholder {
      @apply tw-hidden;
    }
  }
}
.center-spinner {
  margin: 50% auto;
}
</style>
